import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tz"];
import { Component } from 'react';
import partial from 'react-utils/partial';
import memoizeOne from 'react-utils/memoizeOne';
import { attachWrappedComponent } from '../../../utils/decoratorUtils/decoratorUtils';
import { equals, now } from '../../../utils/SimpleDate';
import { jsx as _jsx } from "react/jsx-runtime";
const instancesForTz = {
  userTz: [],
  portalTz: [],
  utc: []
};
const todayForTz = {
  userTz: undefined,
  portalTz: undefined,
  utc: undefined
};
const intervalHandleForTz = {};
const updateToday = tz => {
  const oldToday = todayForTz[tz];
  const newToday = now(tz);
  if (!oldToday || !equals(oldToday, newToday)) {
    todayForTz[tz] = newToday;
    instancesForTz[tz].forEach(instance => instance.forceUpdate());
  }
};
const registerInstance = (instance, tz) => {
  if (!instancesForTz[tz]) instancesForTz[tz] = [];
  const instances = instancesForTz[tz];
  if (instances.length === 0) {
    updateToday(tz);
    intervalHandleForTz[tz] = setInterval(partial(updateToday, tz), 60e3);
  }
  instances.push(instance);
};
const unregisterInstance = (instance, tz) => {
  const instances = instancesForTz[tz];
  const index = instances.indexOf(instance);
  if (index >= 0) instances.splice(index, 1);
  if (instances.length === 0 && intervalHandleForTz[tz]) {
    clearInterval(intervalHandleForTz[tz]);
    delete intervalHandleForTz[tz];
  }
};
const updateInstanceForTz = (instance, tz) => {
  if (instance.tz) {
    unregisterInstance(instance, instance.tz);
  }
  registerInstance(instance, tz);
  instance.tz = tz;
};
export const UsesToday = WrappedComponent => {
  class UsesTodayComponent extends Component {
    constructor(props) {
      super(props);
      this.tz = null;
      this._updateInstanceForTz = memoizeOne(updateInstanceForTz);
      this._updateInstanceForTz(this, props.tz);
    }
    componentWillUnmount() {
      if (this.tz) {
        unregisterInstance(this, this.tz);
      }
    }
    render() {
      const _this$props = this.props,
        {
          tz = 'userTz'
        } = _this$props,
        restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
      this._updateInstanceForTz(this, tz);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        today: todayForTz[tz]
      }, restProps));
    }
  }
  attachWrappedComponent(UsesTodayComponent, WrappedComponent);
  return UsesTodayComponent;
};